import makeRequest, {HttpMethod} from "./request";

import auth from "./auth";
import logout from "./logout";
import verifyTwoFactorCode from "./verifyTwoFactorCode";
import getUserEstablishmentsList from "./getUserEstablishmentsList";
import listAdminModulesActions from "./listAdminModulesActions"
import {authData, establishmentOptions, filtersData} from "../Storages";
import {setTokenTmp} from "../Storages/cookies";

const generateTwoFactorCode = makeRequest('generate-two-factor-code').removeAuthorizationHeader();

// const getLastPixPayments = makeRequest('get-last-pix-payments').prepare(async (params: object) => {
//     const { data: {data: processedData}, response, method } = params as { data: any; response: any, method: HttpMethod };
//     return {data: (processedData ?? []), response, method};
// });

// const getLastCreditDebitCardTransactions = makeRequest('get-last-credit-debit-card-transactions').prepare(async (params: object) => {
//     const { data, response, method } = params as { data: any; response: any, method: HttpMethod };
//     const processedData = (data?.data?.lastTransactions ?? []);
//     return {data: processedData, response, method};
// });

// const transactionInstallmentsDashboardData = makeRequest('transaction_installments_dashboard_data').prepare(async (params: object) => {
//     const { data, response, method } = params as { data: any; response: any, method: HttpMethod };
//     const processedData = data?.data?.transactions;
//     return {data: processedData, response, method};
// });

// const transactions = makeRequest('transactions').prepare(async (params: object) => {
//     const { data, response, method } = params as { data: any; response: any, method: HttpMethod };
//     const processedData = data?.data;
//     return {data: processedData, response, method};
// });

const accessProfile = makeRequest('accessprofile').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };

    if(response?.status === 422) {
        return { data, response, method };
    }

    if (method === 'DELETE') { //remover isso e adicionar de forma decente
        return { data: { data: data, status: response?.status}, response, method };
    }

    if (method === 'PUT' || method === 'POST') {
        return { data: data?.data, response, method };
    }
    return { data, response, method };
});

const listAdminModules = makeRequest('list-admin-modules').prepare(async (params: object) => {
    const { data: processedData, response, method } = params as { data: any; response: any, method: HttpMethod };
    // const processedData = data?.data;
    return { data: processedData, response, method };
});

const accessProfileModulePermission = makeRequest('access-profile-module-permission');

const accessProfileActionPermission = makeRequest('access-profile-action-permission');

const users = makeRequest('users').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };

    if(response?.status === 422) {
        return { data, response, method };
    }

    if(response?.status === 403) {
        return { data, response, method };
    }

    if (method === 'POST' || method === 'PUT') {
        return { data: data?.data, response, method };
    }

    if (method === 'DELETE' && response?.status === 204) {
        const newData = (Object.keys(data || {}).length > 0)? data : {message: 'Usuário removido com sucesso!', status: response?.status};
        return { data: newData, response, method };
    }

    return { data, response, method };
});

const competencias = makeRequest('sped-fiscal/competencias').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };
    const processedData = data?.data;
    return { data: processedData, response, method };
});

const accessProfileToSelectList = makeRequest('accessProfileToSelectList').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };
    const processedData = data?.data;
    return { data: processedData, response, method };
});

const sped = makeRequest('sped').prepare((params: object) => {
    const { data, response, method } = params as { data: any; response: any; method: HttpMethod };

    return { data, response, method };
});
  
const estruturaMercadologica = makeRequest('estruturaMercadologica').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any; method: HttpMethod };

    return { data, response, method };
});

const estruturaMercadologicaRegistros = makeRequest('estruturaMercadologicaRegistros').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any; method: HttpMethod };

    return { data, response, method };
});

const ncm = makeRequest('ncm').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any; method: HttpMethod };

    return { data, response, method };
});

const ean = makeRequest('ean').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any; method: HttpMethod };

    return { data, response, method };
});

const eanRegistros = makeRequest('eanRegistros').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any; method: HttpMethod };

    return { data, response, method };
});

const products = makeRequest('products').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };

    if(response?.status === 422) {
        return { data, response, method };
    }

    if(response?.status === 403) {
        return { data, response, method };
    }

    return { data, response, method };
});

const nfes = makeRequest('nfes').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };

    if(response?.status === 422) {
        return { data, response, method };
    }

    if(response?.status === 403) {
        return { data, response, method };
    }

    return { data, response, method };
});

const establishments = makeRequest('establishments').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };

    if(response?.status === 422) {
        return { data, response, method };
    }

    if(response?.status === 403) {
        return { data, response, method };
    }

    if (method === 'DELETE' && (response?.status === 204 || response?.status === 200)) {
        const newData = (
            (Object.keys(data || {}).length > 0)
            ? {...data, status: response?.status} 
            : {message: 'Estabelecimento removido com sucesso!', status: response?.status}
        );
        return { data: newData, response, method };
    }

    return { data, response, method };
});


export {
    auth,
    logout,
    verifyTwoFactorCode,
    getUserEstablishmentsList,
    generateTwoFactorCode,
    accessProfile,
    listAdminModulesActions,
    listAdminModules,
    accessProfileModulePermission,
    accessProfileActionPermission,
    users,
    accessProfileToSelectList,
    sped,
    estruturaMercadologica,
    estruturaMercadologicaRegistros,
    ncm,
    ean,
    eanRegistros,
    products,
    nfes,
    competencias,
    establishments
}
